import { apiSlice, asyncToastDisplay, i18n} from "./apiSlice";

export const roleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: () => (`/roles`),
      providesTags: (result , error, arg) => [{ type: 'Role', id: "LIST"}],
    }),
    getPublisherRoles: builder.query({
      query: (publisherId) => (`/publishers/${publisherId}/roles`),
      providesTags: (result , error, publisherId) => [{ type: 'Role', id: `LIST:publisher:${publisherId}`}],
    }),
    getDataVendorRoles: builder.query({
      query: (dataVendorId) => (`/data_vendors/${dataVendorId}/roles`),
      providesTags: (result , error, dataVendorId) => [{ type: 'Role', id: `LIST:dataVendor:${dataVendorId}`}],
    }),
  }),
  overrideExisting: false
})

export const {
  useGetRolesQuery,
  useGetPublisherRolesQuery,
  useGetDataVendorRolesQuery
} = roleApiSlice
